import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClearinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 11
		}), /* @__PURE__ */ _jsx("path", { d: "M16 8l-8 8m0-8l8 8" })]
	})
});
export default SvgClearinline;
